import React from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import EventTableContainer from "./event-table-container";

interface Props {}

// TODO PageHeader with ack all / unack all etc.
function AlertsPage(props: Props) {
  // const classes = useStyles(props);
  return (
    <div>
      <Grid justify="space-between" alignItems="center" container>
        <Grid item>
          <Typography variant="h5">Alerts</Typography>
        </Grid>
        {/* <Grid item>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={handleCreateClick}
          >
            Create
          </Button>
        </Grid> */}
      </Grid>
      <EventTableContainer />
    </div>
  );
}

export default AlertsPage;
